import { Directive } from '@angular/core';
import { BrnSheetContent } from '@spartan-ng/brain/sheet';

@Directive({
    hostDirectives: [{ directive: BrnSheetContent, inputs: ['context', 'class'] }],
    selector: '[hlmSheetPortal]',
})
export class HlmSheetPortal {}
